// export const baseUrl = 'http://192.168.251.131/';
export const baseUrl = 'https://139.196.127.180/';





// WEBPACK FOOTER //
// ./src/config.js